import { render, staticRenderFns } from "./TransferBonusPoints.vue?vue&type=template&id=b85927ba&scoped=true&"
import script from "./TransferBonusPoints.vue?vue&type=script&lang=js&"
export * from "./TransferBonusPoints.vue?vue&type=script&lang=js&"
import style0 from "../../less/transfer.less?vue&type=style&index=0&id=b85927ba&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b85927ba",
  null
  
)

export default component.exports